/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { values } from 'lodash'
import UIkit from 'uikit'

// Components
import Loader from 'app/views/components/Loader'
import OrganizationLayout from 'app/views/containers/Organizations/components/Layout'
import UserDetailModal from 'app/views/components/UserDetailModal'
import GenericModal from 'app/views/components/Modals/GenericModal'

// Redux
import { getContent } from 'app/state/modules/content'
import { getTeamsReportUsers } from 'app/state/modules/hacker'
import { getTeams } from 'app/state/modules/team'
import { fetchSelectedUserDetail } from 'app/state/modules/users'
import { deleteHackerFromOrganization } from 'app/state/modules/hacker'


// Utils
import analytics from 'app/views/utils/analytics'
import Lessons from 'app/views/components/LessonsCheckboxList'
import moment from 'moment'


class CustomReport extends React.Component {
  constructor(props) {
    super(props)

    const lastMonth = new Date()
    lastMonth.setMonth(lastMonth.getMonth() - 1)

    this.state = {
      displayResults: false,
      selectedCompleted: 'true',
      selectedLessons: new Set(),
      selectedTeam: '',
      isLoadingContent: true,
    }

    this.handleChangeSelect = this.handleChangeSelect.bind(this)
    this.handleChangeTeam = this.handleChangeTeam.bind(this)
    this.handleClickCheckbox = this.handleClickCheckbox.bind(this)
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleClickGo = this.handleClickGo.bind(this)
    this.onDeleteUser = this.onDeleteUser.bind(this)
    this.onRefLessons = this.onRefLessons.bind(this)
    this.onExport = this.onExport.bind(this)
  }

  componentDidMount() {
    this.props.getContent(this.props.match.params.organization_uuid, true, () => this.setState({ isLoadingContent: false }))
    this.props.getTeams(this.props.match.params.organization_uuid)

    analytics.page('page-organizations-report')
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.match.params.organization_uuid !== this.props.match.params.organization_uuid) {
      this.props.getTeams(nextProps.match.params.organization_uuid)
    }
  }

  onRefLessons(ref) {
    this.checkboxLessons = ref
  }

  onExport() {
    const headers = ['Email', 'Admin', 'License']
    const rows = []
    rows.push(headers)
    this.props.reportUsers.forEach((row) => {
      const hackerRow = []
      hackerRow.push(row.email)
      hackerRow.push(row.role)
      hackerRow.push(JSON.stringify(row.has_license))
      rows.push(hackerRow)
    })
    const csvContent = `data:text/csv;charset=utf-8,${rows.map((e) => {
      return e.join(',')
    }).join('\n')}`
    const encodedUri = encodeURI(csvContent)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `users_report_${moment().format('YYYY-MM-DD')}.csv`)
    document.body.appendChild(link)
    link.click()
  }

  onDeleteUser() {
    const orgUUID = this.props.match.params.organization_uuid
    const userUUID = this.props.selectedUserDetail.uuid || this.props.match.params.hacker_uuid
    const callback = (error = false) => {
      this.modalDeleteUser.hide()
      if (error) {
        return UIkit.modal.alert('<h2 >Error</h2><p>There was an error deleting the user. Please try again or contact support.</p>')
      }
      this.handleClickGo()
      return UIkit.modal.alert('<h2 >User removed</h2><p>The user has been removed successfully from the organization<p>')
    }
    this.props.deleteHackerFromOrganization(orgUUID, userUUID, callback)
  }

  handleChangeSelect(e) {
    this.setState({
      displayResults: false,
      selectedCompleted: e.target.value,
    })
  }


  handleChangeTeam(e) {
    this.setState({
      displayResults: false,
      selectedTeam: e.target.value,
    })
  }

  handleClickCheckbox(e) {
    const { selectedLessons } = this.state
    if (selectedLessons.has(e.target.value)) {
      selectedLessons.delete(e.target.value)
    } else {
      selectedLessons.add(e.target.value)
    }
    this.setState({
      displayResults: false,
      selectedLessons,
    })
  }

  handleClickEdit(e) {
    e.preventDefault()
    this.setState({ displayResults: false })
  }

  handleClickGo(e) {
    if (e) {
      e.preventDefault()
    }
    let completed = false
    if (this.state.selectedCompleted === 'true') {
      completed = true
    }
    const selectedLessons = this.checkboxLessons.getLessons()
    this.props.getTeamsReportUsers(
      this.props.match.params.organization_uuid,
      selectedLessons,
      this.props.match.params.team_uuid ? this.props.match.params.team_uuid : this.state.selectedTeam,
      completed,
    )
    this.setState({
      displayResults: true,
    })
  }

  handleClickGoBack(e) {
    e.preventDefault()

    this.props.history.push(this.props.location.pathname.replace(/[^/]*$/, ''))
  }

  renderDeleteModalContent() {
    if (!this.props.selectedUserDetail) return null
    if (this.props.selectedUserDetail.steps_completed > 20) {
      return (
        <>
          <p>
            {`You are about to remove ${this.props.selectedUserDetail.email} from your organization.
            This user's license does not qualify to be released due to the amount of content they
            have already completed.`}
          </p>
          <p>Are you sure you want to continue?</p>
        </>
      )
    }
    return (
      <>
        <p>
          {`You are about to remove ${this.props.selectedUserDetail.email} from your organization. This
          user's license will be available for reuse since they completed a minimal amount of
          the training.`}
        </p>
        <p>Are you sure you want to continue?</p>
      </>
    )
  }


  render() {
    if (!this.props.hasLoadedTeams || this.state.isLoadingContent) {
      return <Loader visible />
    }
    return (
      <OrganizationLayout
        active="reports"
        data-test-id="standard-report-component"
        noPaddingRemove={(this.props.match.params.team_uuid)}
        style={{ position: 'relative' }}
        {...this.props}
      >

        {(this.props.match.params.team_uuid) && (
          <button
            onClick={() => this.props.history.push(`/admin/${this.props.match.params.organization_uuid}/teams/${this.props.match.params.team_uuid}/users`)}
            className="uk-button uk-button-secondary uk-button-small uk-position-absolute uk-position-top-left uk-margin-top uk-margin-small-left"
            type="button"
          >
            <i data-uk-icon="icon: arrow-left; ratio: 1.5" />
            Back To Team
          </button>
        )}

        <h2 className="uk-text-center">
          Generate a Report
        </h2>
        <UserDetailModal
          localData={this.props.reportUsers}
          selectedUserDetail={this.props.selectedUserDetail}
          onRemoveFromOrg={() => this.modalDeleteUser.show()}
        />
        <GenericModal
          title="Delete user from organization"
          titleInfo={(
            <a
              href="https://help.hackedu.io/en/articles/"
              className="uk-margin-right"
              data-uk-icon="icon: question; ratio: 0.8"
              style={{ padding: 9, verticalAlign: 'top', display: 'inline-block' }}
              target="_blank"
              rel="noopener noreferrer"
            />
          )}
          ref={(ref) => { this.modalDeleteUser = ref }}
          id="delete-user-modal"
          date-test-id="delete-user-modal"
          body={this.renderDeleteModalContent()}
          buttons={(
            <button
              data-test-id="delete-user-confirm"
              type="button"
              className="uk-button uk-button-danger uk-margin-left"
              onClick={this.onDeleteUser}
            >
              Delete
            </button>
          )}
        />
        <div className="uk-card uk-card-default uk-card-body">
          <div className="uk-container-small">
            <form className="uk-grid-small" data-uk-grid>
              <div
                className="uk-width-1-1@s"
                style={{ display: this.state.displayResults ? 'block' : 'none' }}
              >
                <button
                  className="uk-button uk-button-primary tm-button-default"
                  onClick={this.handleClickEdit}
                  type="button"
                >
                  Edit Report
                </button>
              </div>
              <div style={{ display: this.state.displayResults ? 'none' : 'block' }}>
                <div className="uk-width-1-1@s">
                  <div className="uk-margin">
                    Find users from:
                    <select
                      className="uk-select"
                      value={this.state.selectedTeam}
                      onChange={this.handleChangeTeam}
                    >
                      {!this.props.match.params.team_uuid && <option value="">All Teams</option>}
                      {(this.props.match.params.team_uuid ? this.props.teams.filter((team) => team.uuid === this.props.match.params.team_uuid) : this.props.teams).map((team) => (
                        <option key={team.uuid} value={team.uuid}>
                          {team.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="uk-margin">
                    who have:
                    <select
                      data-test-id="select-completed-status"
                      className="uk-select"
                      value={this.state.selectedCompleted}
                      onChange={this.handleChangeSelect}
                    >
                      <option value="true">Completed</option>
                      <option value="false">Not Completed</option>
                    </select>
                  </div>

                  <p>all of the following:</p>
                </div>

                <Lessons ref={this.onRefLessons} content={this.props.courses} />

                <div className="uk-width-1-1@s">
                  <br />
                  <button
                    data-test-id="run-report-btn"
                    className="uk-button uk-button-primary tm-button-default"
                    onClick={this.handleClickGo}
                    type="button"
                  >
                    Run Report
                  </button>
                  &nbsp; &nbsp; &nbsp;
                  <button
                    type="button"
                    className="uk-button uk-button-danger tm-button-default"
                    onClick={this.handleClickGoBack.bind(this)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
        {this.state.displayResults && (
          <div className="uk-padding uk-padding-remove-horizontal">
            {this.props.loadingReportUsers === true ? (
              <Loader visible />
            )
              : (
                <div>
                  {this.props.errorReportUsers ? (
                    <>
                      <p className="uk-text-danger">There was an error with your report</p>
                    </>
                  )
                    : (
                      <div>
                        {this.props.reportUsers.length === 0 ? (
                          <p>No results were found for this report.</p>
                        )
                          : (
                            <div>
                              <p>The following users match the report above.</p>
                              <button
                                onClick={this.onExport}
                                className="uk-button uk-button-default uk-button-small uk-align-right uk-margin-small-left"
                                type="button"
                              >
                                <span className="uk-margin-small-right" data-uk-icon="cloud-download" />
                                Export Data
                              </button>
                              <table className="uk-table uk-table-divider uk-table-responsive">
                                <thead>
                                  <tr>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>License</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.props.reportUsers.map((user, index) => {
                                    let role = 'Member'
                                    if (user.role === 'admin') {
                                      role = 'Admin'
                                    }
                                    return (
                                      <tr key={user.uuid} data-test-id="user-row">
                                        <td>
                                          <a onClick={() => this.props.fetchSelectedUserDetail(
                                            this.props.match.params.organization_uuid,
                                            {
                                              ...user,
                                              justTeam: this.props.match.params.team_uuid,
                                            },
                                            false,
                                            {
                                              localIndex: index,
                                            },
                                          )}
                                          >
                                            {user.email}
                                          </a>
                                        </td>
                                        <td>
                                          <span
                                            className="uk-label uk-label-secondary"
                                            style={{
                                              marginTop: 8,
                                            }}
                                          >
                                            {role}
                                          </span>
                                        </td>
                                        <td>
                                          {user.has_license === true ? (
                                            <div
                                              className="uk-icon-button uk-label-success"
                                              data-uk-icon="check"
                                            />
                                          )
                                            : (
                                              <div className="uk-icon-button" data-uk-icon="close" />
                                            )}
                                        </td>

                                      </tr>
                                    )
                                  })}
                                </tbody>
                              </table>
                            </div>
                          )}
                      </div>
                    )}
                </div>
              )}
          </div>
        )}

      </OrganizationLayout>
    )
  }
}

const mapStateToProps = (state) => ({
  // content
  courses: state.content.content.courses,
  lessonMap: state.content.lessonMap,
  tests: state.content.tests,
  selectedUserDetail: state.users.selectedUserDetail,

  // hacker
  organizations: values(state.hacker.organizationsList),
  organizationsHash: state.hacker.organizationsHash,
  reportUsers: state.hacker.reportUsers,
  errorReportUsers: state.hacker.errorReportUsers,
  mustPassCodingExercise: state.hacker.mustPassCodingExercise,
  loadingReportUsers: state.hacker.loadingReportUsers,

  // team
  teams: state.team.teams,
  hasLoadedTeams: state.team.hasLoadedTeams,

  // user
  email: state.auth.user.email,
})
const mapDispatchToProps = (dispatch) => ({
  getTeams: (organzationId) => dispatch(getTeams(organzationId)),
  getContent: (organizationUUID, includeAllOrganizationContent, callback) => dispatch(getContent(organizationUUID, includeAllOrganizationContent, callback)),
  fetchSelectedUserDetail: (organizationUUID, user, disableLoader, toOverride) => dispatch(fetchSelectedUserDetail(organizationUUID, user, disableLoader, toOverride)),
  getTeamsReportUsers: (organizationId, contentIds, teamId, completed) => dispatch(
    getTeamsReportUsers(organizationId, contentIds, teamId, completed),
  ),
  deleteHackerFromOrganization: (organizationUUID, hackeUUID, callback) => dispatch(deleteHackerFromOrganization(organizationUUID, hackeUUID, callback)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CustomReport))
